/*
 * The Activity tab of an item's details column (S-01 §3.2; S-06 Appendix B), as the `detailsViews`
 * slot takes it: in the group "drive.item" beside Details and a file's Versions, last. It answers for
 * every item; a drive's own root has none (the route reads an item's changes).
 *
 * This file is statically reachable from the module object, so it holds the entry and nothing else:
 * the view itself is a chunk (`ActivityView.tsx`).
 */

import { lazy } from "react"
import type { DetailsView } from "../../../core/modules/registry.ts"
import { client } from "../../../core/store/store.ts"
import { driveSlice } from "../reducer.ts"
import { DETAILS_GROUP } from "../state/details.ts"

/** The view's id, which a request to open it names. */
export const ACTIVITY_VIEW = "drive.activity"

/** Whether the key names an item (not a drive) this visit has met. */
function isItem(key: string | number | undefined): boolean {
	if (typeof key !== "string") return false
	return Object.values(driveSlice(client.api.getState()).items).some((item) => item.key === key)
}

export const activityDetailsView: DetailsView = {
	id: ACTIVITY_VIEW,
	titleKey: "drive.details.tab.activity",
	tabLabelKey: "drive.details.tab.activity",
	group: DETAILS_GROUP,
	order: 30,
	View: lazy(async () => ({ default: (await import("./ActivityView.tsx")).ActivityView })),
	relevant: (params) => isItem(params.key),
}
